module.exports = __webpack_public_path__ + "img/welcome.f2f85c75.svg";